import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment/moment';


@Injectable()
export class ISO8601StringParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct | null {
    if (!value) {
      return null;
    }

    const date = moment(value, 'YYYY-MM-DD', true);
    return { day: date.date(), month: date.month() + 1, year: date.year() };
  }

  // To ISO8601 string
  format(date: NgbDateStruct | null): string {
    return date ? moment({ date: date.day, month: date.month - 1, year: date.year }).toISOString() : '';
  }
}
